module.exports = __webpack_public_path__ + "img/16.38fee9ea.png";